// need reference to window js jquery because Portal Devs
// need to utilize this functionality from old JS files
const $old = jQuery;
import $ from "jquery";
import {merge} from "../general";
import collectDataAttributesFor from "../collectDataAttributesFor";
import {isDesktop} from '../../utilities/uaDetect';
import Fuse from "fuse.js";
import {searchSettings} from "../fuseSearchSettings";

// console.log(searchSettings);

const select2FuseKeys = {
  keys: [{
    name: 'id',
    weight: 0.3
  }, {
    name: 'text',
    weight: 0.7
  }]
};

function filterLogicFunc(el, config) {
  return function filterLogic(data){
    const s2 = el.data('select2');
    const searchInput = s2.dropdown.$search;
    if (!searchInput || !searchInput.val()) {
      return data;
    }
    const term = searchInput.val();
    const select2Fuse = new Fuse(data, config);
    const res = select2Fuse.search(term);
    return res;
  }
}

function matcherByPass(term, obj){
  return obj
}

export function instantiateSelect2(els){
  els.each(function(){
    const el = this;
    const $el = $(this);
    const options = collectDataAttributesFor(el, {prefix: "s2"});
    const resultType = searchSettings[options.searchLogic] || searchSettings.base;
    const select2FuseConfig = merge(resultType, select2FuseKeys, {clone: true});
    //options.matcher = matcherByPass; Commented out to fix the filtering in multi select2. Can be configured for custom filtering in future.
    options.sorter = filterLogicFunc($el, select2FuseConfig);
    $el.select2(options);
    // select2 has baked in functionality that forces the select
    // open after clear. Functionality below allows opting out.
    // if autoOpenOnClear is explicitly equal to false,
    // then we handle keeping the selectbox close on unselecting
    
    const isDisabled = $el.is(':disabled');

    if(isDisabled){
      const disabledTargetEl = $el.data('target-closest');
      const parentEl = $el.closest(disabledTargetEl);
      parentEl.find('.select2-container').css('pointer-events','none');
    }
    
    const isInputGrp = $el.parent().hasClass('q-input-group');
    
    if(isInputGrp){
      const isFirstChild = $el.siblings().first().get(0).tagName === 'SPAN' ? true : false;
      const isLastChild = $el.siblings().last().get(0).tagName === 'SPAN' ? true : false;
      
      if(isFirstChild){
        $el.next().find('.select2-selection').css({
          'border-radius': '3px 0px 0px 3px',
          'border-right': '0px'
        });
      } else if(isLastChild){
        $el.next().find('.select2-selection').css({
          'border-radius': '0px 3px 3px 0px'
        });
      } else {
        $el.next().find('.select2-selection').css({
          'border-radius': '0px',
          'border-right' : '0px'
        });
      }
    } 
    
    const isFullWidthList = options.fullWidthList;
    
    function makeListWidthFull(){
      const $list = $('.select2-dropdown');
      let listWidth = $el.parent().width();
      $list.css({
        'width': `${ listWidth }px`
      });
      // Following takes care of the scenario where select2 is not the first child
      let $elParentLeftPosition = $el.parent().offset().left;
      $list.offset({
        left: $elParentLeftPosition
      });
    }
    
    $el.on('select2:open',()=>{
      if(isFullWidthList){
        setTimeout(makeListWidthFull,1);
        $(window).scroll(()=>{
          makeListWidthFull();
        });
        $(window).resize(()=>{
          makeListWidthFull();
        });
      }
    });
    
    if(options.autoOpenOnClear === false){
      $el.on("select2:unselecting", function (e) {
        $(this).select2("val", 0);
        e.preventDefault();
      });
    }
    
    if($el.data('custom-select2-cls')){
      const customClass = $el.data('custom-select2-cls');
      addCustomClassForSelect2($el, customClass);
    }
  });
}

export function validateOnAllSelectChanges(){
  $(document).on("change", "select", function(){
    if($(this).get(0).form){
      $(this).valid();
    }
  });
}

export function bindDocSelect2CloseRefocus(){
  $(document).on('select2:close', focusTargetFromEvent($));
  $old(document).on('select2:close', focusTargetFromEvent($old));
}

export function addCustomClassForSelect2(select2El, cls){
  select2El.data('select2').$container.addClass(cls);
  select2El.data('select2').$dropdown.addClass(cls);
  select2El.data('select2').$selection.addClass(cls);
}

function focusTargetFromEvent($){
  return (e)=>{
    $(e.target).focus();
  }
}

export function bindSelect2OnTypeForDesktop(){
  if(isDesktop()){
    $(document).on('keydown', 'span.select2', createDropdownSelectSpanFromEvent($));
    $old(document).on('keydown', 'span.select2', createDropdownSelectSpanFromEvent($old));
  }
}

function createDropdownSelectSpanFromEvent($){
  return function dropdownSelectSpanFromEvent(ev){
    let selectEl = $(this).prev('select:not([multiple])');

    let $target = $(ev.target).closest('.select2-container');
    if (!selectEl.data('select2') || !$target.length) {
      return;
    }
    let $search = selectEl.data('select2').dropdown.$search || selectEl.data('select2').selection.$search;

    if ($target.hasClass('select2-container--open')) {
      return;
    }
    searchSelect2Now({selectElement: selectEl, $target, $search, event: ev});
  }

  function searchSelect2Now({selectElement, $target, $search, event}){
    /* NOTE: due to browser comptibility issues, search only filters in Safari and Edge, not in other browsers,
        and attempting to implement search and filter on non-search-input dropdowns created a bug in Edge, which, as
        Microsoft's latest browser, may need to be supported */

    $target = $target.prev();
    /* Might be needed in future, but needs to be rewritten to follow code structure we're targeting */
    // if (!$target.length || !$target.get(0).isEqualNode(this.element[0])) {
    //     return;
    // }

    if (event.which >= 32) {
      /* Safari does not have key */
      let key = event.key ? event.key : String.fromCharCode(event.which);

      if (key.length === 1) {
        $search.val(key);
      }

      selectElement.select2('open');

      let selectObj = selectElement.data('select2');
      selectObj.trigger('query', {term: key});

      // NOTE: select2 component is full of setTimeout functions, so the only way to work around the search input is to put our own in.
      setTimeout(function(){
        $search.caret(1);
      }, 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/select2able/index.js